import { render, staticRenderFns } from "./UiNotification.vue?vue&type=template&id=264365b9&lang=pug&"
import script from "./UiNotification.vue?vue&type=script&lang=ts&"
export * from "./UiNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports